import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { useHistory } from "react-router-dom";
import { NoServiceAccountDetailsMenuList } from "@constants";
import "./css/AccountDetailsMenu.scss";
import { fixUrlLanguage } from "@utils/changeLanguage";

interface IOfferMenuItem {
    externalUrl?: string;
    isBlockedIfNoService: boolean;
    title: string;
    url?: string;
    preventIfInCollection: boolean;
}

export const NoServiceAccountDetailsMenu = () => {
    const history = useHistory();

    const linkOnClickAction = (menuItem: IOfferMenuItem) => {
        if (menuItem.externalUrl) {
            window.location.href = menuItem.externalUrl;
        } else if (menuItem.url) {
            history.push(fixUrlLanguage(menuItem.url));
        }
    };

    return (
        <div className="offer-menu">
            <List component="nav">
                <Grid container spacing={1} wrap="wrap">
                    {NoServiceAccountDetailsMenuList.map((menuItem: IOfferMenuItem) => (
                        <Grid item key={menuItem.title} sm={6} xs={12}>
                            <ListItem button onClick={() => linkOnClickAction(menuItem)}>
                                <ListItemText color="primary" primary={menuItem.title} />
                                <KeyboardArrowRight />
                            </ListItem>
                            <Divider light />
                        </Grid>
                    ))}
                </Grid>
            </List>
        </div>
    );
};
